import { render, staticRenderFns } from "./9-bg.vue?vue&type=template&id=3c6928dc&"
import script from "./9-bg.vue?vue&type=script&lang=js&"
export * from "./9-bg.vue?vue&type=script&lang=js&"
import style0 from "./9-bg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports